<header *ngIf="isReady">

  <div class="header"
       [style.min-height]="headerstyles.headerheight"
       [style.background-color]="headerstyles.headerbackgroundcolor"
  >
    <!-- Nav -->
    <div class="container-xl">
      <div class="row justify-content-between"
           [style.min-height]="headerstyles.headerheight"
      >
        <div class="col-12 col-md-auto align-self-center text-center text-md-left">
          <a [routerLink]="['']"><img class="customer-logo" [src]="headerstyles.headerlogouri"/></a>
        </div>
        <div class="col-12 col-md-auto">
          <div class="row justify-content-between sub-header">
            <div class="col-auto align-self-center center-sm">
              <div class="row">
                <ng-container *ngIf="languages.length > 1">
                  <div class="col-auto lang-container">
                    <div class="d-inline-block">
                      <ng-container *ngFor="let language of languages">
                        <a routerLink=""
                           [ngClass]="{'active': currentlanguage.key === language.key}"
                           (click)="lnginterfacechange(language)"
                           class="lang-button ms-1 me-1 {{headerstyles.headertextcolorclassname}}">{{language.key}}</a>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
                <div class="col-auto help-container">
                  <div class="d-inline-block align-middle">
                    <a (click)="toggleHelp()" [ngClass]="headerstyles.headertextcolorclassname">
                      <i class="fas fa-question-circle fa-lg mouse-pointer"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto align-self-center user-container center-sm">
              <div class="d-inline-block">
                <app-dropdown-user [userinfos]="userinfos" [fullname]="fullname"
                                   [headerstyles]="headerstyles"></app-dropdown-user>
              </div>
              <div class="d-inline-block ms-3 align-middle logout-container">
                <button [ngClass]="headerstyles.headertextcolorclassname" class="btn btn-link"
                        (click)="toggleOrderList()">
                  <i class="fas fa-list-alt fa-xs me-2"></i>{{i18n.get('global_orders_label')}}
                </button>
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Toolbar -->
    <nav *ngIf="true" class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-xl">
        <button class="navbar-toggler" type="button" (click)="toggleToolbar()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="toolbarToggler"
             [ngClass]="{ 'show': navbarOpen }">
          <ul class="navbar-nav me-auto mt-2 mt-lg-0">
            <ng-container *ngIf="isAmongRoles(['ROLE_ADMIN'])">
              <li class="nav-item">
                <a class="nav-link" id="admin" [routerLink]="['/admin']" routerLinkActive="active"
                   [style.background]="headerstyles.headerbackgroundcolor"
                   [ngClass]="headerstyles.headertextcolorclassname"
                   (click)="toggleToolbar()">{{i18n.get('global_admin_portal_label')}}</a>
              </li>
            </ng-container>
            <ng-container *ngFor="let tool of tools">
              <li class="nav-item">
                <a class="nav-link" id="{{tool.toolkeyword}}"
                   [routerLink]="getPortalToolPath(currentlanguage.key, tool.toolid, tool.toolkeyword)"
                   [style.background]="headerstyles.headerbackgroundcolor"
                   [ngClass]="headerstyles.headertextcolorclassname"
                   routerLinkActive="active" (click)="toggleToolbar()">
                  {{ getToolLabel(tool) }}
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Empty tool bar -->
    <nav *ngIf="false" class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-xl">
        <button class="navbar-toggler" type="button" (click)="toggleToolbar()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="toolbarToggler"
             [ngClass]="{ 'show': navbarOpen }">
          <h4>Extranet tools</h4>
        </div>
      </div>
    </nav>

  </div>
</header>
